import useAppSelector from 'stores/useAppSelector';
import type { RootStoreState } from 'data-lake/preview/Types';

const useDLPreviewSelector = <R>(fn: (state: RootStoreState) => R) => useAppSelector<R, RootStoreState>(fn);
export default useDLPreviewSelector;
